<template>
	<v-container class="fill-height" fluid>
		<v-row align="center" justify="center">
			<v-col cols="12" lg="7">
				<v-card class="elevation-12">
					<v-toolbar color="primary" dark flat>
						<v-toolbar-title>{{ $t('login') }}</v-toolbar-title>
						<v-spacer />
					</v-toolbar>
					<v-card-text>
						<v-form @keyup.native.enter="submit" v-model="valid" lazy-validation ref="form">
							<v-text-field
								v-model="form.nickname"
								:rules="nickRules"
								:label="$t('nickname')"
								prepend-icon="mdi-at"
								:error-messages="errors.nickname"
								required
							/>
							<v-text-field
								v-model="form.password"
								:type="passwordShow ? 'text' : 'password'"
								:label="$t('password')"
								prepend-icon="mdi-lock"
								:append-icon="passwordShow ? 'mdi-eye' : 'mdi-eye-off'"
								@click:append="passwordShow = !passwordShow"
								:rules="passwordRules"
								required
							/>
							<v-checkbox v-model="remember" :label="$t('remember_me')" />
						</v-form>
					</v-card-text>
					<v-card-actions>
						<v-spacer />
						<v-btn color="primary" :loading="loading" @click="submit">{{ $t('login_button') }}</v-btn>
					</v-card-actions>
				</v-card>
			</v-col>
		</v-row>
	</v-container>
</template>

<script>
export default {
	name: 'Login',
	middleware: 'guest',
	layout: 'simple',

	data() {
		return {
			form: {
				nickname: '',
				password: ''
			},
			valid: true,
			nickRules: [v => !!v || this.$t('nickname_is_required')],
			passwordRules: [v => !!v || this.$t('password_is_required')],
			passwordShow: false,
			remember: true,
			loading: false,
			errors: {}
		}
	},

	metaInfo() {
		return { title: this.$t('login') }
	},

	watch: {
		form: {
			handler() {
				if (!this.valid) {
					this.$refs.form.resetValidation()
					this.errors = {}
				}
			},
			deep: true
		}
	},

	methods: {
		submit() {
			this.valid = this.$refs.form.validate()

			if (this.valid) {
				this.login()
			}
		},
		async login() {
			this.loading = true
			// Submit the form.
			try {
				const { data } = await this.$http.post('/login', this.form)

				// Save the token.
				await this.$store.dispatch('auth/saveToken', {
					token: data.token,
					remember: this.remember
				})

				// Fetch the user.
				await this.$store.dispatch('auth/fetchUser')

				if (this.modal) {
					this.$emit('close')
					return
				}
				// Redirect home.
				await this.$router.push({ name: '/' })
			} catch ({ response }) {
				this.errors = response.data.errors
				// this.forgotten = true
			}
			this.loading = false
		}
	}
}
</script>
